// extracted by mini-css-extract-plugin
module.exports = {"ProductList":"ProductList_ProductList__Qwokl","DutyFreeModal":"ProductList_DutyFreeModal__UOLx2"};